"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var components_1 = require("@lsg/components");

exports.SpecialComponent = function (hardcodedComponents) {
  return function (_a) {
    var data = _a.data;
    var identifier = data.text('identifier');
    var d = data.field('data').field('internal').field('content').raw();
    var parsedJSON = d && JSON.parse(d); // Error handling

    if (identifier === undefined) {
      return react_1["default"].createElement(Error, null, "Field for identifier is not defined");
    }

    if (hardcodedComponents[identifier] === undefined) {
      return react_1["default"].createElement(Error, null, "No hardcoded component matches the overgiven identifier");
    }

    var Component = hardcodedComponents[identifier];
    return react_1["default"].createElement(Component, __assign({}, parsedJSON));
  };
};

var Error = styled_components_1["default"](components_1.Paragraph)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: #db1818 !important;\n"], ["\n  color: #db1818 !important;\n"])));
var templateObject_1;